import React from "react";
import { useSelector } from "react-redux";
import { getIsMobile } from "selectors/appState";
import { SkeletonItem } from "../skeleton-item/skeleton-item";

interface PayableCashSkeletonProps {
    visible: boolean;
}

export const PayableCashSkeleton = ({ visible }: PayableCashSkeletonProps) => {
    const isMobile = useSelector(getIsMobile);

    if (visible) {
        return (
            <div data-testid="payable-cash-skeleton">
                <div className="ez-pay-balance-frame">
                    <div className="ez-pay-balance-top">
                        <div className="validate-header" style={{ borderBottom: "none" }}>
                            <SkeletonItem width="50%" height="40px" />
                        </div>
                        <div className="ez-pay-balance-divider"></div>
                        <div
                            className="cash-only-primary-display"
                            style={{
                                padding: "24px",
                                margin: isMobile ? "20px auto" : "20px 56px",
                                border: "1px solid #B5B5B5",
                                maxWidth: isMobile ? "327px" : "none",
                                width: isMobile ? "100%" : undefined,
                            }}
                        >
                            <div className="cash-account-logo-container">
                                <SkeletonItem width={isMobile ? "279px" : "171px"} height="40px" />
                                <div
                                    style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        gap: "8px",
                                        alignItems: isMobile ? "flex-start" : "flex-end",
                                        marginTop: isMobile ? "25px" : "0",
                                        width: isMobile ? "100%" : undefined,
                                    }}
                                >
                                    <SkeletonItem width="175px" height="16px" />
                                    <SkeletonItem width="150px" height="16px" />
                                    <SkeletonItem width="125px" height="16px" />
                                </div>
                            </div>
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    marginTop: isMobile ? "0" : "24px",
                                }}
                            >
                                <SkeletonItem width={isMobile ? "279px" : "396px"} height="64px" />
                            </div>
                            <div style={{ display: "flex", flexDirection: "column", gap: "24px", marginTop: isMobile ? "24px" : "40px" }}>
                                <SkeletonItem width="100%" height="40px" />
                                <SkeletonItem width="100%" height="40px" />
                            </div>
                        </div>
                        <div style={{ margin: "32px 56px", display: "flex", flexDirection: "column", gap: "24px", alignItems: isMobile ? "center" : "stretch" }}>
                            <SkeletonItem width="276px" height="24px" />
                            <SkeletonItem width={isMobile ? "327px" : "520px"} height="40px" />
                        </div>
                        <div style={{ margin: "32px 56px", display: "flex", flexDirection: "column", gap: "24px", alignItems: isMobile ? "center" : "stretch" }}>
                            <SkeletonItem width="276px" height="24px" />
                            <SkeletonItem width={isMobile ? "327px" : "520px"} height="40px" />
                        </div>
                        <div style={{ margin: "32px 56px", display: "flex", justifyContent: "center" }}>
                            <SkeletonItem width="123px" height="36px" />
                        </div>
                        <div style={{ margin: "32px 56px", display: "flex", flexDirection: "column", gap: "8px", alignItems: "center" }}>
                            <SkeletonItem width="166px" height="24px" />
                            <SkeletonItem width="119px" height="16px" />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
    return null;
};
